import { render } from "./TextCounseling.vue?vue&type=template&id=6e968aa7"
import script from "./TextCounseling.vue?vue&type=script&lang=js"
export * from "./TextCounseling.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TextCounseling.vue?vue&type=style&index=0&id=6e968aa7&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__